import { Guesses } from "../Guesses";
import { Panel } from "./Panel";
import React from "react";
import { Worldle } from "../Worldle";
import { formatDistance } from "../../domain/geography";
import { SettingsData } from "../../hooks/useSettings";
import Twemoji from "./TwemojiUtils";

interface InfosProps {
  isOpen: boolean;
  close: () => void;
  settingsData: SettingsData;
}

export function InfosJa({ isOpen, close, settingsData }: InfosProps) {
  return (
    <Panel title="遊び方" isOpen={isOpen} close={close}>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
        <div>
          6回以内の回答で
          <Worldle />
          に正解しましょう。
        </div>
        <div>正確な国名・地域名で回答してください。</div>
        <div>
          一度回答するたびに、正解との距離や距離や方角、近さ（%）を確認することができます。
        </div>
      </div>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
        <div className="font-bold">例</div>
        <div>
          <Guesses
            rowCount={1}
            guesses={[
              {
                name: "チリ",
                direction: "NE",
                distance: 13_557_000,
              },
            ]}
            settingsData={settingsData}
          />
          <div className="my-2">
            最初の回答である
            <span className="uppercase font-bold">チリ</span>
            は、正解から
            {formatDistance(13557000, settingsData.distanceUnit)}離れています。
            正解は北東の方角にあり、近さは32%しかありません。
          </div>
        </div>
        <div>
          <Guesses
            rowCount={1}
            guesses={[
              {
                name: "フィンランド",
                direction: "SE",
                distance: 3_206_000,
              },
            ]}
            settingsData={settingsData}
          />
          <div className="my-2">
            二番目に回答した
            <span className="uppercase font-bold">フィンランド</span>
            は正解に近づいています！正解はこの国から
            {formatDistance(3206000, settingsData.distanceUnit)}
            離れていて、南東の方角にあり、近さは84%です。
          </div>
        </div>
        <div>
          <Guesses
            rowCount={1}
            guesses={[
              {
                name: "レバノン",
                direction: "N",
                distance: 0,
              },
            ]}
            settingsData={settingsData}
          />
          <div className="my-2">
            次に、<span className="uppercase font-bold">レバノン</span>
            と回答します。これは正解でした！おめでとうございます
            <Twemoji text="🎉" className="inline-block" />
          </div>
        </div>
      </div>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3 font-bold">
        毎日新しい
        <Worldle />
        を楽しむことができます！
      </div>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
        <div className="font-bold">質問や提案がありますか？</div>
        <div>
          <a
            className="underline"
            href="https://worldle.notion.site/Worldle-b84ab0f002e34866980a4d47cf9291b7"
            target="_blank"
            rel="noopener noreferrer"
          >
            Worldle FAQ
          </a>
          をご覧ください。
        </div>
      </div>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
        <Worldle />
        は、
        <a
          className="underline"
          href="https://www.powerlanguage.co.uk/wordle/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Wordle
        </a>
        （
        <a
          className="underline"
          href="https://twitter.com/powerlanguish"
          target="_blank"
          rel="noopener noreferrer"
        >
          Josh Wardle (@powerlanguish)
        </a>
        作）から<span className="font-bold">多大な</span>
        影響を受けて制作しました。
      </div>
      <div className="space-y-3 text-justify pb-3">
        <div>
          作者：
          <a
            className="underline"
            href="https://twitter.com/teuteuf"
            target="_blank"
            rel="noopener noreferrer"
          >
            @teuteuf
          </a>{" "}
          - (
          <a
            className="underline"
            href="https://github.com/teuteuf/worldle/"
            target="_blank"
            rel="noopener noreferrer"
          >
            source code
          </a>
          )
        </div>
        <div>
          もっと応援したい？
          <a
            className="underline"
            href="https://www.ko-fi.com/teuteuf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Twemoji
              text="☕ コーヒー1杯分をサポート！"
              className="inline-block"
            />
          </a>
        </div>
      </div>
    </Panel>
  );
}
